import {DashboardActionTypes} from '../../../const/dataEnum';
import {enhanceReducer} from '../../../lib/utilities';

export const InitialState = {
  chartData: [],
  selectedMultipleItems: [],
  selectedMultipleQuestions: [],
  questionCategory: [],
  questionFilters: [],
  periodList: [],
  groupedData: [],
  selectedMenu: '',
  xData: [],
  newDataSeries: [],
  categoryScore: {},
};

export const mockSeries = [
  {
    label: 'No Data choosen, selected ',
    data: [],
 },
];

const DashboardReducer = (state, action) => {

  let newState;

  switch (action.type) {
    case DashboardActionTypes.SET_CHART_DATA:
      newState = {...state, chartData: action.payload};
      break;
    case DashboardActionTypes.SET_SELECTED_ITEMS:
      newState = {...state, selectedMultipleItems: action.payload};
      break;
    case DashboardActionTypes.SET_SELECTED_QUESTIONS:
      newState = {...state, selectedMultipleQuestions: action.payload};
      break;
    case DashboardActionTypes.SET_QUESTION_CATEGORY:
      newState = {...state, questionCategory: action.payload};
      break;
    case DashboardActionTypes.SET_QUESTION_FILTERS:
      newState = {...state, questionFilters: action.payload};
      break;
    case DashboardActionTypes.SET_PERIOD_LIST:
      newState = {...state, periodList: action.payload};
      break;
    case DashboardActionTypes.SET_GROUPED_DATA:
      newState = {...state, groupedData: action.payload};
      break;
    case DashboardActionTypes.SET_SELECTED_MENU:
      newState = {...state, selectedMenu: action.payload};
      break;
    case DashboardActionTypes.SET_X_DATA:
      newState = {...state, xData: action.payload};
      break;
    case DashboardActionTypes.SET_NEW_DATA_SERIES:
      newState = {...state, newDataSeries: action.payload};
      break;
    case DashboardActionTypes.SET_CATEGORY_SCORE:
      newState = {...state, categoryScore: action.payload};
      break;
    case DashboardActionTypes.SET_DASHBOARD_DATA:
      newState = {
        ...state, 
        groupedData: action.payload.groupedData,
        categoryScore: action.payload.categoryScore,
        chartData: action.payload.chartData,
        xData: action.payload.xData,
        questionCategory: action.payload.questionCategory,
     };
      break;
    case DashboardActionTypes.SET_CHANGED_CATEGORY:
      newState = {
        ...state,
        newDataSeries: action.payload.filteredSeries,
        questionFilters: action.payload.filteredQuestions,
        selectedMultipleQuestions: action.payload.filteredQuestions
     };
      break;
    default:
      newState = state;
  }

  return newState;
};

export const EnhancedDashboardReducer = enhanceReducer(DashboardReducer);